import React from 'react';
import _ from 'underscore';

import {
  ExperimentalCondition,
  ExperimentalConditionValue,
  StageConfiguration,
  StageRun,
} from 'workflows/WorkflowConstants';

export function experimentalConditionValuesToString(
  experimentalConditionValues: Array<ExperimentalConditionValue>
): string {
  return experimentalConditionValues.length > 0
    ? experimentalConditionValues.map((ecValue) => ecValue.textValue).join(', ')
    : '';
}

export function ExperimentalConditionPopoverContent({
  experimentalConditions,
}: {
  experimentalConditions: Array<ExperimentalCondition>;
}): JSX.Element {
  return (
    <div>
      {experimentalConditions.map((ec, index) => (
        <div key={ec.id || index}>
          <div>
            <strong>{ec.name}</strong>
          </div>
          {ec.values.length > 0 && <p>{ec.values.map((ecValue) => ecValue.textValue).join(', ')}</p>}
        </div>
      ))}
    </div>
  );
}

export function stageConfigurationHasExperimentalConditionValues(
  stageConfiguration: StageConfiguration
): boolean {
  return stageConfiguration.experimentalConditions.some((condition) => condition.values.length > 0);
}

export function getUniqueExperimentalConditionSummaries(
  stageRuns: Array<StageRun>
): Array<ExperimentalCondition> {
  return _.chain(stageRuns)
    .map((stageRun) => stageRun.stageFlowNode.experimentalConditionValues)
    .flatten()
    .pluck('experimentalCondition')
    .uniq('id')
    .value();
}

export function getExperimentalConditionValueNames(stageRuns: Array<StageRun>): Array<string> {
  // eslint-disable-next-line no-restricted-syntax
  return _.pluck(getUniqueExperimentalConditionSummaries(stageRuns), 'name');
}
